<template>
  <div class="assesment">
    <div class="assesment__header">
      <div class="assesment__header__title">
        <h2 class="medium-title">Assesment</h2>
      </div>
    </div>
    <div class="assesment__action">
      <div class="assesment__action__search">
        <i class="adx-ic_search"></i>
        <input type="text" id="search" class="subhead" name="search" placeholder="Search" autocomplete="off" v-model="searchBoxValue">
      </div>
      <div class="assesment__action__filters">
        <adx-dropdown
          @selected="selectAssignee" v-if="listAssignee.length"
          :list="listAssignee"
          :valueDisplay="selectedAssignee.value"
          labelButton="All Assignee"
          class="list-assignee" />
        <adx-dropdown
          @selected="selectCategory" v-if="listCategory.length"
          :list="listCategory"
          :valueDisplay="selectedCategory.value"
          labelButton="All Category"
          class="list-category" />
        <adx-dropdown
          @selected="selectFilterStatus" v-if="listStatus.length"
          :list="listStatus"
          :valueDisplay="selectedFilterStatus.value"
          labelButton="All Status"
          class="list-status" />
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
    </div>
    <div class="assesment__main">
      <div class="assesment__main__list" v-if="!isLoadingList && !isEmptyList">
        <div v-for="ticket in listTicket" :key="ticket.id" class="assesment__main__list__content" :class="{active: selectedTicket.id === ticket.id}" @click="selectTicket(ticket)">
          <div class="assesment__main__list__content__left">
            <div :class="['assesment__main__list__content__left__status', `${ticket.status_display.toLowerCase()}`]"></div>
            <div class="assesment__main__list__content__left__campaign">
              <div class="assesment__main__list__content__left__campaign__placement base-font">{{ticket.placement}}</div>
              <div class="assesment__main__list__content__left__campaign__name small-font">{{ticket.campaign}} • {{ticket.category_display}}</div>
              <div class="assesment__main__list__content__left__campaign__location subhead">{{ ticket.location }}</div>
            </div>
          </div>
          <div class="assesment__main__list__content__right">
            <div class="assesment__main__list__content__right__assignee base-font">
              {{ticket.assignee.full_name}}
            </div>
            <div class="assesment__main__list__content__right__timestamp small-font">
              {{formatDate(ticket.reported_at)}}
            </div>
            <div class="assesment__main__list__content__right__location subhead">
              {{ticket.area}}
            </div>
          </div>
        </div>
      </div>
      <div class="assesment__main__list__loading" v-else-if="isLoadingList"><loading-primary /></div>
      <div v-if="isEmptyList" class="assesment__main__list__emptyState"><adx-empty-selection/></div>
      <div class="assesment__main__detail" v-if="ticketDetail && !isLoadingDetail">
        <div class="assesment__main__detail__location_timestamp">
          <span class="location subhead">{{ ticketDetail.location }}</span>
          <span class="timestamp subhead">{{formatDate(ticketDetail.reported_at)}}</span>
        </div>
        <div class="assesment__main__detail__campaign">
          <div class="assesment__main__detail__campaign__placement small-title">{{ticketDetail.placement}}</div>
          <div class="assesment__main__detail__campaign__name subhead">{{ticketDetail.campaign}} • {{ticketDetail.category_display}}</div>
        </div>
        <div class="assesment__main__detail__maps">
          <GmapMap
            class="assesment__main__detail__maps__map"
            :center="centerMaps"
            :zoom="12"
            map-type-id="terrain"
            ref="mapRef"
            :options="{
              zoomControl: false,
              mapTypeControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false
            }"
          >
            <GmapMarker
              v-for="(m, index) in mapMarkers(ticketDetail.listing_report.images)"
              :key="index +'gmarker'"
              :position="m.position"
              :clickable="true"
              @mouseover="showTooltip(m, index, true)"
              @mouseout="showTooltip(m, index, true)"
            />
          </GmapMap>
        </div>
        <div class="assesment__main__detail__list_thumbnail">
          <div v-for="image in ticketDetail.listing_report.images" :key="image.id" class="assesment__main__detail__list_thumbnail__thumbnail">
            <a :href="image.image" target="_blank"><img :src="image.thumbnail"></a>
          </div>
        </div>
        <div class="assesment__main__detail__status">
          <!-- <adx-input
            label="Status"
            value="normal"
            :disabled="true"/> -->
          <adx-select-dropdown
            v-if="category === VISIT"
            :options="listStatus"
            :value.sync="selectedStatus"
            label="Status"
          />
          <adx-select-dropdown
            v-if="selectedStatus == 2 || category === MAINTENANCE"
            :options="listIssueType"
            :value.sync="selectedIssueType"
            label="Issue Type"
          />
          <adx-select-dropdown
            v-if="category === MAINTENANCE"
            :options="listIssueStatus"
            :value.sync="selectedIssueStatus"
            label="Issue Status"
          />
        </div>
        <div class="assesment__main__detail__description">
          <div class="assesment__main__detail__description__label subhead">Description</div>
          <div class="assesment__main__detail__description__text subhead">{{ticketDetail.listing_report.description || ''}}</div>
        </div>
        <div class="assesment__main__detail__assignee">
          <div class="assesment__main__detail__assignee__label">Assignee</div>
          <div class="assesment__main__detail__assignee__text subhead">{{ticketDetail.assignee.full_name}}</div>
        </div>
        <div class="assesment__main__detail__action" v-if="category === VISIT">
          <button class="primary btn-regular approve" @click="approve()">Approve</button>
          <button class="secondary btn-regular reject" @click="reject()">Reject</button>
        </div>
        <div class="assesment__main__detail__action" v-else>
          <button class="primary btn-regular submit" @click="approve()">Submit</button>
        </div>
      </div>
      <div class="assesment__main__detail__loading" v-else-if="isLoadingDetail"><loading-primary /></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LoadingPrimary from '@/components/Loading/Primary'
import Dropdown from '@/components/Dropdown/ListDropdown'
import SelectDropdown from '@/components/Form/SelectDropdown'
import EmptySelection from '@/components/NotFound/Selection'
import Input from '@/components/Form/Input'
import * as validationLib from '@/lib/validation/'

import api from '@/api'
import { apiV2 } from '@/api/urls'
const {
  helpers
} = validationLib

export default {
  name: 'adx-admin-assesment',
  components: {
    'adx-dropdown': Dropdown,
    'loading-primary': LoadingPrimary,
    'adx-select-dropdown': SelectDropdown,
    'adx-empty-selection': EmptySelection,
    'adx-input': Input,
  },
  props: {

  },
  data() {
    return {
      category: null,
      VISIT: 0,
      MAINTENANCE: 1,
      listAssignee: [
      ],
      listCategory: [
        {
          id: 1,
          label: 'Visit',
          value: 1,
        },
        {
          id: 2,
          label: 'Maintenance',
          value: 2,
        }
      ],
      listStatus: [
        {
          id: 1,
          label: 'Normal',
          value: 1,
        },
        {
          id: 2,
          label: 'Warning',
          value: 2,
        }
      ],
      listIssueType: [
        {
          id: 0,
          label: 'No Issue',
          value: 0,
        },
        {
          id: 1,
          label: 'Display Problem',
          value: 1,
        },
        {
          id: 2,
          label: 'Delivery Problem',
          value: 2,
        },
        {
          id: 3,
          label: 'Others',
          value: 3,
        },
      ],
      listIssueStatus: [
        {
          id: 1,
          label: 'Open',
          value: 1,
        },
        {
          id: 2,
          label: 'Resolve',
          value: 2,
        }
      ],
      isLoadingList: false,
      isLoadingDetail: false,
      isEmptyList: false,
      listTicket: [],
      selectedTicket: null,
      ticketDetail: null,
      selectedStatus: 1,
      selectedIssueType: 0,
      selectedIssueStatus: null,
      markers : [
      ],
      searchBoxValue: '',
      selectedAssignee: {
        label: null,
        value: null
      },
      selectedCategory: {
        label: null,
        value: null
      },
      selectedFilterStatus: {
        label: null,
        value: null
      },
      centerMaps: null
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedFilterStatus.value || this.selectedCategory.value || this.selectedAssignee.value || this.searchBoxValue !== ''){
        filtered = true
      }
      return filtered
    },
    getFilterParams: function () {
      let category_value = undefined
      if (this.selectedCategory.value) {
        if (this.selectedCategory.value === 1) category_value = '0'
        else if(this.selectedCategory.value === 2) category_value = '1'
      }

      let report_status_value = undefined
      if (this.selectedFilterStatus.value) {
        if (this.selectedFilterStatus.value === 1) report_status_value = '0'
        else if(this.selectedFilterStatus.value === 2) report_status_value = '1'
      }
      const params = {
        search: this.searchBoxValue || undefined,
        assignee: this.selectedAssignee.value || undefined,
        category: category_value || undefined,
        listing_report__status: report_status_value || undefined
      }
      return params
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getTickets()
      })
    }, 500),
    selectedAssignee: function () {
      this.$nextTick(() => {
        this.getTickets()
      });
    },
    selectedCategory: function () {
      this.$nextTick(() => {
        this.getTickets()
      });
    },
    selectedFilterStatus: function () {
      this.$nextTick(() => {
        this.getTickets()
      });
    },
  },
  beforeCreate() {

  },
  created() {
    this.getAssignee()
    this.getTickets()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getTickets() {
      (async () => {
        this.isEmptyList = false
        this.isLoadingList = true
        let params = {
          ...this.getFilterParams
        }
        const response = await api.get(apiV2.listReportedTicket, {needToken: true, params})
        if (response.status == 200) {
          this.listTicket = response.data
          if (!this.listTicket.length) {
            this.isEmptyList = true
            this.ticketDetail = null
            this.isLoadingDetail = false
          } else {
            this.isEmptyList = false
            this.selectedTicket = this.listTicket[0]
            this.getTicketDetail()
          }
        }
        this.isLoadingList = false
      })();
    },
    getAssignee() {
       (async () => {
        const response = await api.get(apiV2.getTeamOps, {needToken: true})
        if (response.status == 200) {
          this.listAssignee = response.data.map(x => {
            return {
              id: x.id,
              value: x.id,
              label: x.full_name
            }
          })
        }
      })();
    },
    getTicketDetail() {
      (async () => {
        this.isLoadingDetail = true
        const ticketId = this.selectedTicket.id
        const response = await api.get(apiV2.detailReportedTicket(ticketId), {needToken: true})
        if (response.status == 200) {
          this.ticketDetail = response.data
          this.selectedStatus = this.ticketDetail.listing_status_key + 1
          this.category = this.ticketDetail.category
          if (this.ticketDetail.listing_report.images.length > 0) {
            const img = this.ticketDetail.listing_report.images[0]
            this.centerMaps = {
              lat: img.latitude,
              lng: img.longitude
            }
          }
          if (this.category === this.MAINTENANCE) {
            this.selectedIssueStatus = this.ticketDetail.listing_issue.status + 1
            this.selectedIssueType = this.ticketDetail.listing_issue.type + 1
          }
        }
        this.isLoadingDetail = false
      })();
    },
    approve() {
      (async () => {
        this.isLoadingDetail = true
        const ticketId = this.selectedTicket.id
        let body = {}
        switch(this.category) {
          case this.VISIT:
            body = {
              status: this.selectedStatus - 1
            }
            if (this.selectedStatus != 1) {
              body['type'] = this.selectedIssueType - 1
            }
            break;
          case this.MAINTENANCE:
            body = {
              status: this.selectedIssueStatus - 1,
              type: this.selectedIssueType - 1
            }
            break;
        }
        const response = await api.post(apiV2.approveReportedTicket(ticketId), body,{needToken: true})
        if (response.status == 200) {
          this.getTickets()
        } else {
          this.isLoadingDetail = false
          if (response.status == 400) {
            const { error } = response.data
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: error,
              type: 'danger'
            });
          } else if (response.status == 404) {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Ticket Not Found',
              type: 'danger'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
          }
        }
      })();
    },
    reject() {
      (async () => {
        this.isLoadingDetail = true
        const ticketId = this.selectedTicket.id
        const body = {
          status: this.selectedStatus - 1
        }
        const response = await api.post(apiV2.rejectReportedTicket(ticketId), body,{needToken: true})
        if (response.status == 200) {
          this.getTickets()
        } else {
          this.isLoadingDetail = false
          if (response.status == 400) {
            const { error } = response.data
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: error,
              type: 'danger'
            });
          } else if (response.status == 404) {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Ticket Not Found',
              type: 'danger'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
          }
        }
      })();
    },
    selectAssignee(item){
      this.selectedAssignee = item
    },
    selectCategory(item){
      this.selectedCategory = item
    },
    selectFilterStatus(item){
      this.selectedFilterStatus = item
    },
    selectTicket(ticket) {
      this.selectedTicket = ticket
      this.getTicketDetail()
    },
    resetFilter() {
      let assignee = {
          label: null,
          value: null,
        }
      let category = {
          label: null,
          value: null,
        }
      let status = {
          label: null,
          value: null,
        }
      this.searchBoxValue = ''
      this.selectAssignee(assignee)
      this.selectCategory(category)
      this.selectFilterStatus(status)
    },
    mapMarkers(data) {
      return data.map(image => {
        return {
          window_open: false,
          disableDefaultUI: true,
          position:
            {
              lat: image.latitude,
              lng: image.longitude
            }
        }
      })
    },
    formatDate(date) {
      if (date) {
        const dateFormat = moment(date, 'DD/MM/YYYY HH:mm:ss')
        return `${dateFormat.format('DD MMM YYYY')} at ${dateFormat.format('HH:mm')}`
      }
      return '-'
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>